import React from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'react-bootstrap';

const ThemeToggleComponent = ({
  onClick,
  userConfiguration
}) => (
  <NavItem onClick={() => onClick(userConfiguration)}>
    {userConfiguration.darkMode ? 'Light' : 'Dark' }
  </NavItem>
);

ThemeToggleComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  userConfiguration: PropTypes.object.isRequired
};

export default ThemeToggleComponent;


// WEBPACK FOOTER //
// src/Components/ThemeToggleComponent.jsx